export default __webpack_public_path__ + "static/media/25f7552c-6777-4120-9a9c-98f9a1f10774.1d38f5d1.png";